export enum MaterialType {
  File = 'file',
  ExternalLink = 'external_link',
}
